export const IS_LOCAL_INSTANCE = false
export const BACKEND_URL =  `${IS_LOCAL_INSTANCE ? "http://localhost:8000" : "https://api.onwardflightticket.com"}`
export const FLIGHT_PDF_BACKEND_URL = `${BACKEND_URL}/ticket/hello.pdf`
export const AUTOCOMPLETE_AIRPORT_BACKEND_URL = `${BACKEND_URL}/api/airports/`
export const LOCAL_BACKEND_URL = "http://localhost:8000"
export const FLIGHT_PDF_LOCAL_BACKEND_URL = "http://localhost:8000/ticket/hello.pdf"
export const AUTOCOMPLETE_AIRPORT_LOCAL_BACKEND_URL = `${LOCAL_BACKEND_URL}/api/airports/`

// Airlines to ignore logos
export const AIRLINE_IGNORE_LOGO_LIST = {"FD": "AirAsia"}